// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"512bdafc","453":"a135a803","455":"927382b3","521":"9e55724a","540":"201c283a","777":"80d672d4","889":"72464ced","997":"91fd24b6"}[chunkId] + ".chunk.js";
};